/* ============================================================
   Domain bar. Reduced-motion aware (audit A-24).
   ============================================================ */

import { html } from '../shared/html.js';

export function DomainBar({ name, percentage, color, weight, scored = true }) {
  const row = document.createElement('div');
  row.className = 'domain-bar-row';

  const pct = scored ? Math.max(0, Math.min(100, Math.round(percentage))) : 0;

  row.innerHTML = html`
    <div class="domain-bar-name" title="${name} · ${weight}% weight">${name}</div>
    <div
      class="domain-bar-track"
      role="img"
      aria-label="${name}: ${scored ? `${pct} percent maturity` : 'not applicable'}"
    >
      <div class="domain-bar-fill" style="width: 0%; background: ${color};"></div>
    </div>
    <div class="domain-bar-val num">${scored ? `${pct}%` : 'n/a'}</div>
  `;

  if (scored) {
    const fill = row.querySelector('.domain-bar-fill');
    const reduced =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced) fill.style.width = `${pct}%`;
    else requestAnimationFrame(() => requestAnimationFrame(() => (fill.style.width = `${pct}%`)));
  }

  return row;
}
